export enum OpportunityCalendarEvent {
    DueDate = 1,
    FollowUpContactDate
}
